"use client";

import type { StoryRecord } from "../../_types/content";
import StoryLinkCard from "./StoryLinkCard";
import FeaturedCarousel from "./ui/FeaturedCarousel";

export default function FeaturedStoryCarousel({
  records,
  compact = false,
}: {
  records: readonly StoryRecord[];
  compact?: boolean;
}) {
  return (
    <FeaturedCarousel
      title="Featured stories"
      items={records}
      getKey={({ story }) => story.id}
      compact={compact}
      renderItem={(record, index) => (
        <StoryLinkCard
          {...record}
          index={index}
          presentation={compact ? "compact" : "carousel"}
        />
      )}
    />
  );
}
